<template>
  <div class="mapping">
    <div class="content">


      <div class="Files-top">
        <div class="ic-left">
          <span>产能管理</span>
        </div>
        <div class="btns">
          <el-button type="primary" @click="add_ed(0)">手工填报</el-button>
          <el-button type="primary" @click="exportList" class="last-el-button">导出</el-button>
        </div>
      </div>
      <div class="unify-search-input-btn" style="margin-top:15px">
        <div class="input-small">
          <span class="search-name">选择车间：</span>
          <el-select v-model="workshop" placeholder="请选择车间" @change='changeSelect'>
            <el-option v-for="item in options" :key="item.id" :label="item.capacityName" :value="item.id"> </el-option>
          </el-select>
          <span class="search-name ml-2">开始时间：</span>
          <el-date-picker v-model="startDate" type="date" placeholder="选择开始时间" :picker-options="pickerOptions">
          </el-date-picker>
          <span class="search-name ml-2">结束时间：</span>
          <el-date-picker v-model="endDate" type="date" placeholder="选择结束时间" :picker-options="pickerOptions">
          </el-date-picker>
          <el-button type="primary" @click="getList" plain class="search-btn">查询</el-button>

        </div>

      </div>

      <div class="mapping-table">
        <el-table :data="tableData" v-loading="loading" stripe style="width: 100%" :height="heights">
          <template slot="empty">
            <span class="noData">
              <img src="@/assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column label="序号" width="90" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="capacityName" label="映射名称" width="305"> </el-table-column>
          <el-table-column label="时间" width="204">
            <template slot-scope="scope"><span>{{ scope.row.recordDay | date_format}}</span></template>
          </el-table-column>
          <el-table-column prop="capacityValue" label="产量" width="204">

          </el-table-column>
          <el-table-column label="填报类型" width="204">
            <template slot-scope="scope"><span>{{ scope.row.sourcesType =='REMOTE' ? '自动填报' : '手工填报'}}</span></template>
          </el-table-column>

          <el-table-column label="操作" align="center">
            <template #default="{row}">
              <span class="buttoned_box">
                <el-button type="text" @click="edit_ed(row,0)" v-if="row.sourcesType =='REMOTE'"
                  style="color:#409eff;font-weight: bold">修正</el-button>
                <el-button type="text" @click="edit_ed(row,1)" v-else
                  style="color:#409eff;font-weight: bold">编辑</el-button>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <downloadTable ref="downloadTable"></downloadTable>
    </div>

    <!-- 新增修改 -->
    <el-dialog width="30%" v-dialogDrag :title="textMap[dialogStatus]" :close-on-click-modal='false'
      :visible.sync="dialogVisible">
      <div class="dialogs">

        <el-form :model="temp" ref="temp" :rules="rules" style="width: 80%;height: 180px;padding-top: 10px;">
          <el-form-item label="映射名称:" prop="capacityName">
            <el-input v-model="temp.capacityName" disabled></el-input>
          </el-form-item>

          <el-form-item label="产量:" prop="capacityValue">
            <el-input v-model="temp.capacityValue"></el-input>
          </el-form-item>
          <el-form-item label="日期:" prop="recordDay">
            <el-date-picker v-model="temp.recordDay" type="date" size="mini" placeholder="选择日期"
              :disabled='editType == 0' :picker-options="pickerOptions"> </el-date-picker>
            <!-- <p style="color:#5e6d82;font-size:12px">Tip：多个设备请用英文逗号隔开</p> -->
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">保存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import {getMappingList,recordFindList,recordUpdateValue,recordSave,recordUpdateInfo} from "../../api/capacity";
  import elRadioTree from '@/components/module/tree/elRadioTree.vue'
  import downloadTable from '@/components/module/downloadTable/downloadTable.vue'
  export default {
    components: {
      elRadioTree,
      downloadTable
    },
    data () {
      return {
        heights: document.getElementById('app').clientHeight-250,//屏幕高度 - 导航栏高度
        loading: false,
        dialogVisible: false,
        dialogStatus: '',
        textMap: {
          add: "新增填报",
          edit: "编辑填报"
        },
        temp: {
          'capacityName': "",
          'localDevice': "",
          'localDeviceNo': ""
        },
        rules: {
          capacityName: [
            {required: true,message: '请输入映射名称',trigger: 'blur'}
          ],
          recordDay: [
            {required: true,message: '请选择日期',trigger: 'blur'}
          ],
          capacityValue: [
            {required: true,message: '请输入产量',trigger: 'blur'}
          ]
        },
        tableData: [],
        startDate: "",
        endDate: new Date(),
        options: [],
        nowWorkshop: {},
        workshop: '',
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },

        },
        editType: 0
      };
    },

    mounted () {
      //    this.getList()
      this.getSelectList()
      var date=new Date();
      date.setDate(1);
      var cTime=new Date(new Date(date).toLocaleDateString()).getTime();
      this.startDate=cTime

    },
    computed: {
      unitId () {
        return this.$store.unitStore.state.nowUnit
      },
    },
    watch: {
      unitId () {
        this.getSelectList()
      },
    },

    methods: {
      //获取下拉框列表
      getSelectList () {
        var id=this.unitId.id
        this.tableData=[]
        getMappingList({'unitId': id}).then(res => {
          if(res.code==200) {
            this.options=res.data
            if(this.options.length!=0) {
              this.nowWorkshop=res.data[0]
              this.workshop=res.data[0].id
              this.getList()
            }

          }
        })
      },
      //获取数据
      getList () {
        this.loading=true
        var d={
          sourcesId: this.nowWorkshop.id,
          startDate: typeof this.startDate=='number'? this.startDate:this.startDate.getTime(),
          endDate: typeof this.endDate=='number'? this.endDate:this.endDate.getTime(),
        }
        recordFindList(d).then(res => {
          if(res.code==200) {
            this.tableData=res.data
            this.tableData.forEach(item => item.capacityName=this.nowWorkshop.capacityName)
            this.loading=false
          } else {
            res.message? this.$message.error(res.message):this.$message.error('查询失败，请检查配置！！')
            this.loading=false
          }
        })
      },
      //下拉框
      changeSelect (val) {
        var arr=this.options.filter(item => item.id==val)
        this.nowWorkshop=arr[0]
        this.getList()
      },

      // 添加弹窗
      add_ed (v,l) {
        this.editType=1
        this.temp={}
        this.temp.capacityName=this.nowWorkshop.capacityName
        this.dialogStatus='add';
        this.dialogVisible=true;
        this.topLevel=v
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
        // this.temp = { EnergyTypeParentId: v || null};
      },
      // 确认添加
      add_fn (formName) {
        this.$refs[formName].validate(valid => {
          if(valid) {
            var d={
              sourcesType: "MANUAL",
              capacityValue: this.temp.capacityValue,
              recordDay: this.temp.recordDay.getTime(),
              sourcesId: this.nowWorkshop.id,
            }
            recordSave(d).then(res => {
              if(res.code==200) {
                //  var data = res.data
                //  data.capacityName = this.nowWorkshop.capacityName
                this.getList();
                // this.tableData.push(data)
                this.dialogVisible=false;
                this.$message({showClose: true,message: '添加成功',type: 'success'});
              } else {
                if(res.message) {
                  this.$message.error(res.message);
                } else {
                  this.$message.error('添加失败');
                }
              }
            })


          } else {
            return false;
          }
        });
      },

      // 确认编辑
      edit_fn () {
        this.$refs['temp'].validate(valid => {
          if(valid) {
            var data=this.temp
            var d={
              "capacityValue": data.capacityValue,
              "id": data.id,
            }
            console.log(d);
            var index=this.tableData.findIndex(item => item.id==data.id)
            if(this.editType==0) { //修正
              recordUpdateValue(d).then(res => {
                if(res.code==200) {
                  //  this.getList();
                  this.tableData[index].capacityValue=res.data.capacityValue
                  this.dialogVisible=false;
                  this.$message({showClose: true,message: '修正成功',type: 'success'});
                } else {
                  res.message? this.$message.error(res.message):this.$message.error('修正失败')

                }
              })
            } else { //编辑
              d.recordDay=typeof data.recordDay=='number'? data.recordDay:data.recordDay.getTime()
              recordUpdateInfo(d).then(res => {
                if(res.code==200) {
                  //  this.tableData[index].capacityValue = res.data.capacityValue
                  this.getList();
                  this.dialogVisible=false;
                  this.$message({showClose: true,message: '编辑成功',type: 'success'});
                } else {
                  res.message? this.$message.error(res.message):this.$message.error('编辑失败')
                }
              })
            }

          } else {
            return false;
          }
        });
      },
      //编辑弹窗 0 为自动填报，1为手工填报
      edit_ed (v,type) {
        if(type==0) {
          this.textMap.edit='修正自动填报'
        } else {
          this.textMap.edit='编辑手工填报'
        }
        this.editType=type

        this.dialogStatus='edit';
        this.temp=Object.assign({},v);
        this.temp.capacityName=this.nowWorkshop.capacityName
        this.dialogVisible=true;
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });




      },
      //下载表格excel
      exportList () {
        let time=new Date();
        let year=time.getFullYear();
        let month=time.getMonth()+1;
        let day=time.getDate();

        const tHeader=[];
        this.$refs.downloadTable.export2Excel(tHeader,this.tableData,year+"-"+month+"-"+day+'-产量管理','.mapping-table')
      },



    },
    filters: {
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';
        let strDate=Y+M+D;
        return strDate
      },
    }
  };
</script>

<style lang="scss" scoped>
  .mapping {
    width: 100%;
    height: 100%;
    background-color: #ebf4ff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;

    .content {
      width: 100%;
      height: 100%;
      padding: 12px 20px 20px 20px;
      box-sizing: border-box;
      background-color: #fff;

      .mapping-table {
        margin-top: 20px;

        /deep/.el-table th.is-leaf {
          border-bottom: 0px;
        }

        .buttoned_box {
          display: flex;
          justify-content: center;
          align-items: center;

          .line {
            display: inline-block;
            width: 1px;
            height: 20px;
            background-color: #E6E6E6;
            margin: 0px 20px;
          }

          .buttoned {
            cursor: pointer;
          }

          /deep/.el-button span {
            font-size: 15px;
            font-weight: 400;
          }
        }
      }

    }

    .dialogs {
      /deep/.el-input__inner {
        width: 250px;
      }
    }

    /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #f5f5f5;

      span {
        color: #67A3ED;
        font-size: 16px;
      }

      .el-icon-close {
        font-size: 22px !important;
      }

    }

    /deep/.el-dialog__footer {
      margin-top: 20px;
      text-align: right !important;
      border-top: 1px solid #f5f5f5;

      button {
        padding: 8px 17px;
      }
    }

    /deep/.el_Tree_Body {
      height: 99.5%;
    }

    .demo-temp {
      display: flex;
      flex-wrap: wrap;
    }

    /deep/.el-form-item {
      display: flex;
      margin-left: 20px;
    }

    /deep/.el-form-item__label {
      white-space: nowrap;
      width: 85px;
    }

    /deep/.el-dialog__body {
      padding: 20px 0px 0px 20px !important;
    }

  }
</style>